(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-campaign', {
                parent: 'entity',
                url: '/communication-campaign?page&sort&title&channel&cancelled&sendingDone&desiredSendDateFrom&desiredSendDateTo',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_READ_ONLY'],
                    pageTitle: 'wamasysApp.communicationCampaign.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaigns.html',
                        controller: 'CommunicationCampaignController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'createdDate,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.new', {
                parent: 'communication-campaign',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaign-form.html',
                        controller: 'CommunicationCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function() {
                        return {
                            title: null,
                            channel: null,
                            desiredSendDate: null,
                            cancelled: false,
                            sendingDone: false,
                            templateTxt: null,
                            templateHtml: null,
                            templateSubject: null,
                            contratIds: [],
                            contratCount: 0,
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.edit', {
                parent: 'communication-campaign',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/communication-campaign/communication-campaign-form.html',
                        controller: 'CommunicationCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'CommunicationCampaign', function($stateParams, CommunicationCampaign) {
                        return CommunicationCampaign.get({ id: $stateParams.id }).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('contrat');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-campaign.cancel', {
                parent: 'communication-campaign',
                url: '/{id}/cancel',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CommunicationCampaign', function($stateParams, $state, $uibModal, CommunicationCampaign) {
                    $uibModal.open({
                        templateUrl: 'app/business/communication-campaign/communication-campaign-cancel-dialog.html',
                        controller: 'CommunicationCampaignCancelController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: function() {
                                return CommunicationCampaign.get({ id: $stateParams.id }).$promise;
                            }
                        }
                    }).result.then(function() {
                        $state.go('communication-campaign', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
